import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {classes, keyframes, stylesheet} from 'typestyle';
import onClickOutside from 'react-onclickoutside';
import {observer} from 'mobx-react';
import {observable} from 'mobx';
import {I18n} from '../../i18n/i18n';

import {Report} from '../types/Report';
import {ErrorColorFaded20, LightGreyColor, Shadow2, WhiteColor, BlackColorFaded10} from '../../styles/colors';

interface ReportListOptionButtonProps {
    report: Report;
    openReportGenerationModal: (report: Report) => void;
    editReport: (report: Report) => void;
    setReportRemovalModal: (idReport?: number) => void;
    downloadingReportIds: number[];
}

@observer
class ReportListOptionButton extends React.Component<ReportListOptionButtonProps> {
    @observable private foldoutVisible = false;

    public handleClickOutside = (): void => {
        this.foldoutVisible = false;
    };

    private isDownloading() {
        return this.props.downloadingReportIds.some((idReport) => idReport === this.props.report.id);
    }

    private renderFoldoutMenu() {
        return (
            <div className={classes(optionButtonCss.foldoutContainer, 'foldDown')}>
                <div className={optionButtonCss.foldoutItem} onClick={() => this.props.editReport(this.props.report)}>
                    <I18n i18nKey={'report:editReport'} />
                </div>
                <div
                    className={classes(optionButtonCss.foldoutItem, this.isDownloading() ? 'downloading' : undefined)}
                    onClick={() => this.props.openReportGenerationModal(this.props.report)}>
                    <I18n i18nKey={'report:downloadReport'} />
                </div>
                <div className={optionButtonCss.foldoutItem} onClick={() => this.props.setReportRemovalModal(this.props.report.id)}>
                    <I18n i18nKey={'report:removeReport'} />
                </div>
            </div>
        );
    }

    public render() {
        return (
            <div className={optionButtonCss.reportOptionButton} onClick={() => (this.foldoutVisible = true)}>
                <FontAwesomeIcon icon="ellipsis-v" />
                {this.foldoutVisible ? this.renderFoldoutMenu() : null}
            </div>
        );
    }
}

export default onClickOutside(ReportListOptionButton);

const blink = keyframes({
    '0%': {
        backgroundColor: 'transparent',
    },
    '50%': {
        backgroundColor: ErrorColorFaded20,
    },
});

const optionButtonCss = stylesheet({
    foldoutItem: {
        textAlign: 'left',
        transition: '.2s',
        padding: 15,
        whiteSpace: 'nowrap',
        $nest: {
            '&:hover': {
                backgroundColor: BlackColorFaded10,
            },
            '&.downloading': {
                animationName: blink,
                animation: '2s infinite',
            },
            '&.disabled': {
                color: LightGreyColor,
            },
        },
    },
    foldoutContainer: {
        zIndex: 2,
        position: 'absolute',
        backgroundColor: WhiteColor,
        minWidth: 180,
        borderRadius: 2,
        border: '1px solid ' + LightGreyColor,
        boxShadow: Shadow2,
        $nest: {
            '&.foldDown': {
                top: 0,
                right: 0,
            },
            '&.foldUp': {
                bottom: 0,
                right: 0,
            },
        },
    },
    reportOptionButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        position: 'relative',
        width: 30,
        height: '100%',
        border: 'none',
        backgroundColor: 'transparent',
        transition: '0.2s',
        $nest: {
            '&:focus': {
                outline: 'none',
            },
            '&:hover': {
                backgroundColor: LightGreyColor,
            },
        },
    },
});



// WEBPACK FOOTER //
// ./src/report/views/ReportListOptionButton.tsx